/**
 * cn — className birleştirici (clsx + tailwind-merge).
 *
 * shadcn/ui pattern: tailwind class'larını koşullu birleştirmek ve
 * çakışmaları tailwind-merge ile çözmek için kullanılır.
 *
 * @example
 *   cn('p-4', condition && 'bg-red-500', className)
 */

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
